import { gql } from 'graphql-tag';

export const GET_SUPPLIER_DETAILS = gql`
  query Id7d909a494bca1258b33fe9c8a1fd2685($id: ID!) {
    __typename
  }
`;
